import { Link } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";
import StatusBadge from "./StatusBadge";
import { timeAgo } from "../utils/timeAgo";
export default function PostsTable({
  posts,
  onDelete,
  deletingId,
}) {

  const { isDark } = useTheme();

  return (
    <div
      className={`
        overflow-hidden
        rounded-3xl
        border
        ${
          isDark
            ? "border-white/10"
            : "border-gray-200"
        }
      `}
    >
      <table className="w-full">

        <thead
          className={
            isDark
              ? "bg-white/5"
              : "bg-gray-50"
          }
        >
          <tr>

            <th className="p-4 text-left">
              Title
            </th>

            <th className="p-4 text-left">
              Category
            </th>

            <th className="p-4 text-left">
              Status
            </th>

            <th className="p-4 text-left">
              Views
            </th>

            <th className="p-4 text-left">
              Publish At
            </th>


            <th className="p-4 text-left">
              Actions
            </th>

          </tr>
        </thead>

        <tbody>

          {posts.map((post) => (

            <tr
              key={post.id}
              className={`
                border-t
                ${
                  isDark
                    ? "border-white/10"
                    : "border-gray-200"
                }
              `}
            >
              <td className="p-4">
                <a href={`/blog/${post.slug}`}>{post.title}</a>
              </td>

              <td className="p-4">
                {post.category_name}
              </td>

              <td className="p-4">
                <StatusBadge
                  status={post.status}
                />
              </td>

              <td className="p-4">
                {post.views}
              </td>

              <td className="p-4">
                {timeAgo(post.published_at)}
              </td>

              <td className="p-4">

                <div className="flex gap-3">

                  <Link
                    to={`/admin/posts/${post.id}/edit`}
                    className="text-blue-800"
                  >
                    Edit
                  </Link>

                  <button
                      onClick={() => onDelete(post.id)}
                      disabled={deletingId === post.id}
                      className="text-red-500 disabled:opacity-50"
                  >
                      {deletingId === post.id ? "Deleting..." : "Delete"}
                  </button>

                </div>

              </td>

            </tr>

          ))}

        </tbody>

      </table>
    </div>
  );
}